import React, { useEffect, useState } from "react";
import apiClient from "../../../auth/apiClient";

import {
	Container
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import ComposesTable from "./ComposesTable";
import useCancellationToken from "../../../hooks/useCancellationToken";
import { useStyles } from "./styles";
import EditorDrawer from "./EditorDrawer";
import DeleteDialog from "./DeleteDialog";
import DevicesDrawer from "./ComposesTable/DevicesDrawer";
import { useDockerManagementContext } from "./DockerManagementProvider";

const DockerManagement = () => {
	const classes = useStyles();
	const {
		actions: { setConfiguration, showError }
	} = useDockerManagementContext();
	const { execute: getConfiguration, cancel: cancelQuery, inProgress } = useCancellationToken({
		func: async function ({ cancelToken }) {
			const response = await apiClient.get(`docker-support`, {
				cancelToken: cancelToken
			});
			setConfiguration(response.data);
		}, errHandleFunc: (err) => {
			showError('Failed to load docker support configuration' + err);
		},
	});

	useEffect(() => {
		getConfiguration();

		return () => {
			cancelQuery();
		}
	}, []);

	return <Container>
		{inProgress ?
			<Container>
				<Skeleton className={classes.skeleton} variant="rect" width='50vw' height="2rem" animation="wave" />
				<Skeleton className={classes.skeleton} variant="rect" width='50vw' height="2rem" animation="wave" />
				<Skeleton className={classes.skeleton} variant="rect" width='50vw' height="2rem" animation="wave" />
			</Container>
			:
			<>
				<ComposesTable/>
				<EditorDrawer />
				<DeleteDialog/>
				<DevicesDrawer/>
			</>
		}
	</Container>
};

export default DockerManagement;
